import store from '@/store'
import qs from 'qs'
import type { DataViewFilters } from '@/services/types'
import {
  ContentPackage,
  PackageProposals,
  Package,
  PackageFilters,
  PackageProposal,
  Packages,
  PackagesProposals,
  PackagesProposalsResponse,
  PackageCoverUploadResponse,
  offeredPackageStatus,
  PostPackagePayload,
  PutPackagePayload,
  AcceptAllProposalsPayload
} from '@/services/content/package/types'
import api from '@/services/api'
import i18n from '@/i18n'
import { ProposalMessages } from '@/interfaces'

const postContentProposal = async (data): Promise<PackageProposal> => {
  try {
    const a = await api.post<PackageProposal>('/content/package/proposal', data)
    return a.data
  } catch (error) {
    throw error as Error
  }
}
const getProposals = async (params?: DataViewFilters & { status: offeredPackageStatus }): Promise<PackagesProposals> => {
  const response = await api.get<PackagesProposalsResponse>('/publisher/packages/proposals', {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
  const data = response.data
  if (!params) {
    return data
  }
  let count = 0
  data.proposals.forEach((e) => {
    if (e.status === 'pending') count += 1
  })
  data.total_pending_per_page = count
  return data
}
const getPublisherProposal = async (id: string, pageNumber: number): Promise<PackageProposals> => {
  const a = await api.get(`/publisher/packages/proposal?id=${id}&page_number=${pageNumber}`)
  return a.data
}

const postPublisherProposal = async (
  proposal_id: string,
  accept_proposal: boolean,
  messages?: ProposalMessages
): Promise<void> => {
  try {
    await api.post<void>('/publisher/packages/proposal', {
      proposal_id,
      accept_proposal
    })
    store.dispatch('messages/addMessage', {
      message: messages?.success ?? i18n.global.t(accept_proposal ? 'content-package-accepted-message' : 'content-package-decline-message'),
      type: 'success'
    })
  } catch (error) {
    store.dispatch('messages/addMessage', {
      message: messages?.error ?? error.response.data.error.description,
      type: 'error'
    })
  }
}
const getPublisherPackages = async (filters: PackageFilters): Promise<Packages> => {
  const a = await api.get<Packages>('/publisher/packages', {
    params: filters,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
  return a.data
}

const AcceptAllProposals = async (payload?: AcceptAllProposalsPayload): Promise<ContentPackage> => {
  const { data } = await api.post<ContentPackage>('/publisher/packages/proposals', payload)
  return data
}

const getPackages = async (filters: PackageFilters): Promise<Packages> => {
  const a = await api.get<Packages>('/content/packages', {
    params: filters,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
  return a.data
}
const getContentPackage = async (id: number): Promise<ContentPackage> => {
  const a = await api.get<ContentPackage>(`/content/package?package_id=${id}`)
  return a.data
}
const postPackage = async (payload: PostPackagePayload): Promise<Package> => {
  const { data } = await api.post<Package>('/content/package', payload)
  return data
}

const postPackageCoverImage = async (cover_image: File): Promise<PackageCoverUploadResponse> => {
  const formData = new FormData()
  formData.append('cover_image', cover_image)
  const res = await api.post('/content/package/cover', formData)
  return res.data
}

const updatePackage = async (payload: PutPackagePayload): Promise<ContentPackage> => {
  const { data } = await api.put<ContentPackage>('/content/package', payload)
  return data
}

export default {
  postContentProposal,
  getProposals,
  getPublisherProposal,
  postPublisherProposal,
  getPublisherPackages,
  getPackages,
  getContentPackage,
  postPackage,
  updatePackage,
  postPackageCoverImage,
  AcceptAllProposals
}
